import { render, staticRenderFns } from "./CashRegisters.vue?vue&type=template&id=c7db34a6"
import script from "./CashRegisters.vue?vue&type=script&lang=js"
export * from "./CashRegisters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports